import script from "./Ambassador.vue?vue&type=script&setup=true&lang=js"
export * from "./Ambassador.vue?vue&type=script&setup=true&lang=js"

import "./Ambassador.vue?vue&type=style&index=0&id=1693a4ad&scoped=true&lang=css"

import exportComponent from "E:\\cymcorp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1693a4ad"]])

export default __exports__